import { createContext, useCallback, useContext, useMemo, useState, startTransition } from "react";
import AddToCartConfirmation from "../components/cart/AddToCartConfirmation";
import { allowsHalfDozen, getItemsPerBox, itemsToBoxes } from "../helpers/aa-products";

const AddToCartContext = createContext(null);

export function AddToCartProvider({ children }) {
  const [state, setState] = useState(null);

  const showAddedToCart = useCallback((product, quantity) => {
    const items = Number(quantity) || 0;
    const boxes = itemsToBoxes(items, product);
    // A half-dozen is less than a box, so a customer's add is reported in pieces
    // rather than rounding to "1 box".
    const inPieces = allowsHalfDozen(product) && (boxes < 1 || items % getItemsPerBox(product) !== 0);
    startTransition(() => {
      setState({
        productName: product?.name || "",
        boxes: boxes > 0 ? boxes : 1,
        pieces: inPieces ? items : null
      });
    });
  }, []);

  const close = useCallback(() => {
    startTransition(() => setState(null));
  }, []);

  const value = useMemo(
    () => ({
      showAddedToCart,
      close
    }),
    [showAddedToCart, close]
  );

  return (
    <AddToCartContext.Provider value={value}>
      {children}
      <AddToCartConfirmation
        isOpen={Boolean(state)}
        productName={state?.productName}
        boxes={state?.boxes}
        pieces={state?.pieces}
        onClose={close}
        onContinue={close}
      />
    </AddToCartContext.Provider>
  );
}

export function useAddToCartConfirmation() {
  const ctx = useContext(AddToCartContext);
  if (!ctx) {
    throw new Error("useAddToCartConfirmation must be used within AddToCartProvider");
  }
  return ctx;
}
